import { Grid } from '@alfalab/core-components/grid';
import { Space } from '@alfalab/core-components/space';
import { createCn } from 'bem-react-classname';

import { ButtonSubmit } from '@components/ButtonSubmit';
import { SecurityGuarantee } from '@components/SecurityGuarantee';

const cn = createCn('form');

export const MobileFormFooter = () => (
    <Space fullWidth={true}>
        <Grid.Row>
            <Grid.Col>
                <ButtonSubmit />
            </Grid.Col>
        </Grid.Row>
        <Grid.Row gutter={{ mobile: 0 }}>
            <div className={cn('footer')}>
                <Grid.Col>
                    <SecurityGuarantee />
                </Grid.Col>
            </div>
        </Grid.Row>
    </Space>
);
